module.exports = __webpack_public_path__ + "img/10.5a52a20.png";